import { render, staticRenderFns } from "./integralRemind.vue?vue&type=template&id=ebafa9dc&scoped=true&"
import script from "./integralRemind.vue?vue&type=script&lang=js&"
export * from "./integralRemind.vue?vue&type=script&lang=js&"
import style0 from "./integralRemind.vue?vue&type=style&index=0&id=ebafa9dc&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebafa9dc",
  null
  
)

export default component.exports